<tec-list-layout>
	<tec-title-group [title]="operationGroup?.title" [tooltip]="operationGroup?.tooltip"></tec-title-group>

	<ng-container content>
		@if (id === OPERATION_TYPE.OCR) {
			<tec-tabs [tabs]="tabs" (tabSelected)="tabSelected($event)" />
		}
		<tec-table-filter [selection]="{all: false, ids: []}">
			@if (toolbar && toolbar()) {
				<tec-toolbar
					[toolbar]="toolbar()"
					[maxFilter]="4"
					(formFilter)="filterChange($event)"
				></tec-toolbar>
			}
			<tec-table
				[headers]="header"
				[rows]="content"
				[config]="config"
				(sortEvent)="sortChange($event)"
				(cellEvent)="tableCell($event)"
				(rowEvent)="tableRow($event)"
				(paginationChange)="paginationChange($event)"
			></tec-table>
		</tec-table-filter>
	</ng-container>
</tec-list-layout>